/** Seconds as m:ss for the OTP countdowns, e.g. 120 -> "2:00", 59 -> "0:59". */
export const formatCountdown = (seconds) => {
  const total = Math.max(0, Math.floor(Number(seconds) || 0));
  const m = Math.floor(total / 60);
  const s = String(total % 60).padStart(2, "0");
  return `${m}:${s}`;
};
